import React, {FunctionComponent} from "react";
import {createUseStyles} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import clsx from "clsx";

const useStyles = createUseStyles({
    notificationBubble: {
        backgroundColor: "#AF0606",
        border: "1px solid #FFFFFFAA",
        borderRadius: 7,
        width: 14,
        height: 14,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
});

type NotificationBubbleProps = {
    className?:string
}

const NotificationBubble:FunctionComponent<NotificationBubbleProps> = (props) => {
    const {children, className} = props;
    const classes = useStyles();
    return (
        <div className={clsx(classes.notificationBubble,className)}>
            <DisplayText variant={TextVariant.s7med} color="white">{children}</DisplayText>
        </div>
    );
};

export default NotificationBubble;